import { IconPlayerSetting } from '../../../../icons';
import { PlayerControlButton, SettingPanelItem, SettingWrapper } from '../../../Player/styles';
import Panel from '../../../Player/styles/Panel';
import { useEffect, useRef, useState } from 'react';
import IconAutoplay from '../../../../icons/IconAutoplay';
import { settingControllerKey } from '../../../Player/PlayerModels';
import ControlBarAudioPanel from './ControlBarAudioPanel';
import PlaybackRateSelector from './ControlBarPlayBackRate';
import ControlBarQualityLevelPanel from './ControlBarQualityLevelPanel';
import theme from '../../../../theme';
import lscache from 'lscache';
import UsePlayerProps from '../../../../Store/usePlayerProps';
import ControlBarNativeCaptionPanel from './ControlBarNativeCaptionPanel';
import ControlBarCaptionPanel from './ControlBarCaptionPanel';

const Setting = ({ player, changeCaptionPosition, emitActivePanel }: {
  player: HTMLVideoElement;
  changeCaptionPosition: boolean;
  emitActivePanel: (status: boolean) => void;
}) => {
  const playerGlobalState = UsePlayerProps((state) => state.playerState);
  const setPlayerGlobalState = UsePlayerProps((state) => state.setPlayerState);
  const { contentConfigs, contentData, sources } = playerGlobalState;
  const [isOpen, setIsOpen] = useState(false);
  // const [playerTech, setPlayerTech] = useState<'hls' | 'mp4'>('hls');
  const [autoNextEpisode, setAutoNextEpisode] = useState<boolean>(true);
  const [activeSetting, setActiveSetting] = useState<settingControllerKey>(null);
  const contentType = contentData?.content?.type;
  const [isMobile, setIsMobile] = useState(false);
  const IS_IOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  const video: any = document.getElementById('simple-player');

  const resizeTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  useEffect(() => {
    if (window) {
      const config = lscache.get('player_config');
      if (config) {
        // setPlayerTech(config.tech);
        setAutoNextEpisode(config.autoNextEpisode);
      }
      handleMobileBreakpoint();
      throttledHandle();
      window.addEventListener('resize', throttledHandle, { passive: true });
    }
    return () => {
      window.removeEventListener('resize', throttledHandle);
      if (resizeTimerRef.current) {
        clearTimeout(resizeTimerRef.current);
        resizeTimerRef.current = null;
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    emitActivePanel(isOpen);
    setActiveSetting(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  const throttledHandle = () => {
    if (resizeTimerRef.current !== null) return;
    resizeTimerRef.current = setTimeout(() => {
      handleMobileBreakpoint();
      resizeTimerRef.current = null;
    }, 100);
  };

  const handleMobileBreakpoint = () => {
    setIsMobile(Number(theme.breakpoints.md) > Number(window.innerWidth));
  };

  // const handlePlayerTechChange = () => {
  //   lscache.set('player_config', { ...lscache.get('player_config'), tech: playerTech === 'hls' ? 'mp4' : 'hls' });
  //   setPlayerTech(playerTech === 'hls' ? 'mp4' : 'hls');
  //   window.location.reload();
  // };

  const handleSetAutoNextEpisode = () => {
    lscache.set('player_config', { ...lscache.get('player_config'), autoNextEpisode: !autoNextEpisode });
    setPlayerGlobalState({
      ...playerGlobalState,
      showingNextEpisode: !autoNextEpisode,
    });
    setAutoNextEpisode(!autoNextEpisode);
  };

  return (
    <>
      <PlayerControlButton
        size="semiLarge"
        icon={<IconPlayerSetting />}
        active={isOpen}
        mr={isMobile ? 0.5 : 1.5}
        onClick={() => setIsOpen(!isOpen)}
      />
      <Panel horizontalPos={{ right: '1.5rem' }} onClose={() => setIsOpen(false)} show={isOpen} customPadding={{ default: '1rem 0', responsive: '0.5rem 0' }}>
        <SettingWrapper>
          {!activeSetting && (
            <>
              {/* {contentConfigs?.urls?.length && !contentConfigs?.urls[0].url.includes('gp00') && <SettingPanelItem*/}
              {/*  icon={<IconPlayerTech />}*/}
              {/*  label={'player.play_simple'}*/}
              {/*  onClick={handlePlayerTechChange}*/}
              {/*  checked={playerTech === 'mp4'}*/}
              {/* />}*/}

              {contentType && contentConfigs?.playback_type !== 'live_stream' && contentType === 'episode' && contentConfigs?.next_episode && (
                <SettingPanelItem
                  icon={<IconAutoplay />}
                  label={'player.auto_nex_episode'}
                  onClick={handleSetAutoNextEpisode}
                  checked={autoNextEpisode}
                />
              )}
            </>
          )}

          {video?.audioTracks && video.audioTracks.length > 1 && (
            <ControlBarAudioPanel
              activeSetting={activeSetting}
              handleSettingItemClick={(controllerKey: settingControllerKey) => setActiveSetting(controllerKey)}
            />
          )}

          {!IS_IOS && !!(sources?.captionFiles?.length) && (sources?.captionFiles?.length > 1) && (
            <ControlBarCaptionPanel
              activeSetting={activeSetting}
              player={player}
              handleSettingItemClick={(controllerKey: settingControllerKey) => setActiveSetting(controllerKey)}
              changePosition={changeCaptionPosition}
            />
          )}

          {IS_IOS && !!(sources?.captions?.length) && <ControlBarNativeCaptionPanel
            activeSetting={activeSetting}
            handleSettingItemClick={(controllerKey: settingControllerKey) => setActiveSetting(controllerKey)}
          />}

          <PlaybackRateSelector
            activeSetting={activeSetting}
            player={player}
            handleSettingItemClick={(controllerKey: settingControllerKey) => setActiveSetting(controllerKey)}
          />

          {sources?.videos.length && (
            <ControlBarQualityLevelPanel
              activeSetting={activeSetting}
              player={player}
              handleSettingItemClick={(controllerKey: settingControllerKey) => setActiveSetting(controllerKey)}
            />
          )}
        </SettingWrapper>
      </Panel>
    </>
  );
};

export default Setting;
